import React from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ProjectSettings } from '../../../../../../pages/project/settings/ProjectSettings';
import { projectSettingsParamsSchema } from '../../../../../../routing/schemas';
import { getProjectQueryOptions } from '../../../../../../rest-api/queries/sharedQueries';

export const Route = createFileRoute('/_private/_home/project/$project_id/settings')({
  params: {
    // Non-numeric project id in the URL is a 404, not an app error
    parse: (rawParams) => {
      const parsed = projectSettingsParamsSchema.safeParse(rawParams);
      if (!parsed.success) {
        throw notFound();
      }
      return parsed.data;
    },
    stringify: ({ project_id }) => ({ project_id: String(project_id) }),
  },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(getProjectQueryOptions(context.apiClient, params.project_id)),
  component: ProjectSettingsRoute,
});

function ProjectSettingsRoute() {
  const { project_id } = Route.useParams();
  const { apiClient } = Route.useRouteContext();
  return <ProjectSettings projectId={project_id} portalApiClient={apiClient} />;
}
